import React, { useState } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap'
import DeleteModal from "components/Common/DeleteModal"
import { adminPrefix } from 'configs/routePrefix'
import AppoinmentService from "services/Admin/AppoinmentService"
import FeedbackModal from "../FeedbackModal"
import StatusModal from "../StatusModal"
import { useSelector } from "react-redux"
import { toast } from 'react-toastify';


const CardItem = ({ history, item, setShouldGetData }) => {
    const appoinmentService = new AppoinmentService()
    const AuthData = useSelector(state => state.Auth)
    const [modalStatus, setModalStatus] = useState(false)
    const [feedbackModal, setFeedbackModal] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)
    const toggle = () => setDropdownOpen(prevState => !prevState)
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")

    const handleCloseModal = (action) => {
        setDeleteModal(false)
        if (action === "delete") {
            setShouldGetData(true)
        }
    }
    return (
        <>
            <tr  >
                <th className="font-size-14">{item.id}</th>
                <th className="font-size-14">{!!item?.title ? item?.title : '-'}</th>
                <th className="font-size-14">{!!item.date.split(' ')[0] ? item.date.split(' ')[0] : '-'}</th>
                <th className="font-size-14">{!!item.date.split(' ')[1] ? item.date.split(' ')[1] : '-'} {!!item.date?.split(' ')[2] ? item.date?.split(' ')[2] : '-'}</th>
                <th className="font-size-14">{!!item.sales_rep?.name ? item.sales_rep?.name : '-'}</th>
                <th className="font-size-14">{item.type}</th>
                <th className="font-size-14">
                    <Badge
                        className="bgBadge-admin font-size-14 m-0 text-white"
                        style={{ background: getBackGround(item.status) }}
                    >
                        {item.status}
                    </Badge>
                </th>
                <td className="removebtnhover">
                    <Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                            <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={() => history.push(`${adminPrefix}/appoinments/view-appoinment/${item?.id}`)}>View</DropdownItem>
                            {isExist("appointment.edit") ?
                                <DropdownItem onClick={() => history.push(`${adminPrefix}/appoinments/edit-appoinment/${item?.id}`)}>Edit</DropdownItem>
                                : null}
                            {isExist("appointment.feedback") ? <DropdownItem onClick={() =>{
                                if(!item?.sales_rep?.id){
                                    toast.error("Please assign Sales Rep ")
                                }else{
                                    setFeedbackModal(true)
                                }
                            }}>Add Feedback</DropdownItem>
                                   : null}
                            {isExist("appointment.delete") ?
                                <DropdownItem className="text-danger" onClick={() => { setDeleteModal(true) }}>Remove Appointment</DropdownItem>
                                : null}
                            {isExist("appointment.edit") ?
                                <>
                                    <hr className="m-0 p-0" />
                                    <DropdownItem onClick={() => setModalStatus(true)} style={{ color: "#212529" }}>Change Status</DropdownItem>
                                </>
                                : null}
                        </DropdownMenu>
                    </Dropdown>
                </td>
            </tr>
            {deleteModal && <DeleteModal
                open={deleteModal}
                titleMsg={"Appoinment"}
                deletedItem={item}
                modelService={appoinmentService}
                onCloseModal={(action) => handleCloseModal(action)}
            />}
            {modalStatus && <StatusModal
                modal={modalStatus}
                toggle={() => setModalStatus(!modalStatus)}
                status={item.status}
                id={item?.id}
                item={item}
                setShouldGetData={setShouldGetData}
            />}
            {feedbackModal && <FeedbackModal modal={feedbackModal} id={item?.id} toggle={() => setFeedbackModal(!feedbackModal)} />}
        </>

    )
}
const getBackGround = (status) => {
    return status === "Done" ? "#34e38f"
        : status === "Upcoming" ? "#50a5f1" : "#74788d"
}

export default CardItem